import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field } from 'redux-form';
//
import { TextAreaField } from 'components/FormFields/TextAreaField';
import { Button } from 'components';

@reduxForm({
  form: 'declineNotesForm',
})
export class NotesForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    notesPlaceholder: PropTypes.string,
  };

  render() {
    const { handleSubmit, notesPlaceholder } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-center"
        data-testid="decline-notes-form"
      >
        <Field
          name="note"
          placeholder={notesPlaceholder}
          component={TextAreaField}
          maxLength={1000}
        />
        <Button
          type="submit"
          className="_red mt-29"
          style={{ width: '180px' }}
          dataTestId="decline"
        >
          Decline
        </Button>
      </form>
    );
  }
}
